import { Reveal, SectionLabel } from "./Reveal";

const stats = [
  { en: "REGISTERED FIRM", hi: "रजिस्टर्ड फर्म" },
  { en: "SERVICE AREA", hi: "मुज़फ्फरनगर व आसपास" },
  { en: "SEGMENTS", hi: "कॉर्पोरेट · हॉस्पिटल · सरकारी" },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-3">
        <SectionLabel>[ 01 — परिचय / WHO WE ARE ]</SectionLabel>
      </Reveal>
      <div className="lg:col-span-9">
        <Reveal delay={0.1}>
          <p
            data-testid="about-manifesto"
            className="font-khand font-medium text-3xl sm:text-4xl lg:text-5xl leading-snug text-white"
          >
            Super Cleaner Services — आधुनिक तकनीकों, पर्यावरण-अनुकूल रसायनों और{" "}
            <span className="text-[#00F0FF]">प्रशिक्षित कार्यबल</span> के माध्यम से कॉर्पोरेट
            कार्यालयों, आईटी पार्कों और व्यावसायिक संपत्तियों को{" "}
            <span className="text-[#00F0FF]">स्वच्छ व कीटाणुरहित</span> वातावरण प्रदान करती है।
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div data-testid="about-office-image" className="mt-12 border border-white/10 overflow-hidden group">
            <img
              src="/images/office-building.jpg"
              alt="Super Cleaner Services — Government Registered Contractor"
              className="w-full aspect-[21/9] object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <p className="mt-3 font-spacemono text-[10px] tracking-[0.3em] text-slate-500 uppercase">
            Government Registered Contractor · Muzaffarnagar, UP
          </p>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 border-t border-white/10">
          {stats.map((s, i) => (
            <Reveal key={s.en} delay={0.15 + i * 0.1} className="border-b sm:border-b-0 sm:border-r last:border-r-0 border-white/10 py-8 sm:pr-8">
              <p className="font-spacemono text-[10px] tracking-[0.3em] text-slate-500 uppercase">
                {s.en}
              </p>
              <p data-testid={`about-stat-${i}`} className="mt-2 font-khand text-2xl text-white">
                {s.hi}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
